import { io } from 'socket.io-client';
import { SOCKET_URL } from './apiBaseUrl.js';

export const createRealtimeConnection = (token) => {
    return io(SOCKET_URL, {
        auth: { token },
        transports: ['websocket', 'polling'],
        withCredentials: true,
        reconnection: true,
        reconnectionAttempts: 8,
        reconnectionDelay: 1000,
    });
};
